/* Reusable empty / no-results placeholder: dashed box, Doto title (via the
   global .text-doto class) and a muted message. */
.wrapper {
    text-align: center;
    padding: 3rem 1rem;
    border: 2px dashed var(--color-gray-200);
    background-color: var(--color-brand-cream-100);
}

.icon {
    display: inline-flex;
    color: var(--color-gray-400);
    margin-bottom: 0.75rem;
}

/* Weight, letter-spacing and case come from .text-doto */
.title {
    font-size: 1rem;
    color: var(--color-gray-500);
    margin: 0 0 0.5rem;
    line-height: 1.5;
}

.message {
    font-size: 0.875rem;
    color: var(--color-gray-400);
    margin: 0;
    line-height: 1.5;
    white-space: pre-line;
}

.action {
    margin-top: 1rem;
}
